import styled from '@emotion/styled';

interface FoldProps {
  height: number;
}

const caculateDeg = (height: number, width: number, outside: number) => {
  const len = Math.sqrt(height ** 2 + width ** 2) / 2;
  return Math.atan(outside / len);
};

export const Fold = styled.div<FoldProps>`
  background-color: @gray-lighter;
  background-image: linear-gradient(170deg, rgba(135, 135, 135, 0.15), rgba(135, 135, 135, 0.02));
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  height: ${props => (props.height ? props.height - 12 : 100)}pt;
  position: absolute;
  right: -10pt;
  top: 0;
  transform: skewX(${props => caculateDeg(props.height - 12, 30, 10)}rad);
  width: 30pt;
`;
